import { combineReducers } from 'redux';
import { i18nReducer } from 'react-redux-i18n';

import pedigree from './pedigree';

export default combineReducers({
	pedigree,
	i18n: i18nReducer
});